module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "offset-sm1": "",
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "display-1"
  }, [_vm._v("Contacto")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "warning",
      "value": _vm.form_error
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form_message)
    }
  })]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "success",
      "value": _vm.form_success
    }
  }, [_vm._v("\n\t\t\t  " + _vm._s(_vm.form_message) + "\n\t\t")]), _vm._v(" "), (!_vm.form_success) ? _c('v-card', {
    staticClass: "elevation-3 card-item"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "label": "Nombre",
      "rules": _vm.nombreRules,
      "required": ""
    },
    model: {
      value: (_vm.nombre),
      callback: function($$v) {
        _vm.nombre = $$v
      },
      expression: "nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "label": "E-mail",
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "label": "Comentarios",
      "rules": _vm.mensajeRules,
      "required": "",
      "counter": 10,
      "multi-line": ""
    },
    model: {
      value: (_vm.mensaje),
      callback: function($$v) {
        _vm.mensaje = $$v
      },
      expression: "mensaje"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    class: {
      green: _vm.valid, white: !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Enviar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332ea149"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 79
// module chunks = 1